import React from 'react';
import { PaymentMethod } from '../../types/index';
import { Plus, Trash2, Calendar, Clock } from 'lucide-react';
import SelectMetodoPagamento from './SelectMetodoPagamento';

/**
 * Lista dinâmica de métodos de pagamento para pagamento misto (2+).
 */
export default function LinhasPagamentoMisto({
  payments,
  onPaymentsChange,
  isEditing = false,
  isAdminOrOwner = false,
  isEmployeeComplexEditing = false,
  minPayments = 2
}) {
  const updatePayment = (index, updates) => {
    onPaymentsChange(payments.map((p, i) => (i === index ? { ...p, ...updates } : p)));
  };

  const addPayment = () => {
    onPaymentsChange([
      ...payments,
      { method: PaymentMethod.CARD, value: '', paymentDate: '', paymentTime: '' }
    ]);
  };

  const removePayment = (index) => {
    if (payments.length <= minPayments) return;
    onPaymentsChange(payments.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-4">
      {payments.map((payment, index) => {
        const isFirst = index === 0;
        const valueReadOnly = isEmployeeComplexEditing && isFirst;

        return (
          <div
            key={index}
            className="bg-slate-50 border-2 border-slate-100 rounded-2xl p-4 space-y-3 relative"
          >
            <div className="flex items-center justify-between">
              <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                Pagamento {index + 1}
              </span>
              {payments.length > minPayments && !isEmployeeComplexEditing && (
                <button
                  type="button"
                  onClick={() => removePayment(index)}
                  className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                  aria-label={`Remover pagamento ${index + 1}`}
                >
                  <Trash2 size={16} />
                </button>
              )}
            </div>

            <SelectMetodoPagamento
              value={payment.method}
              onChange={(val) => updatePayment(index, { method: val })}
              disabled={false}
            />

            <input
              type="number"
              step="0.01"
              min="0"
              required
              value={payment.value}
              onChange={(e) => !valueReadOnly && updatePayment(index, { value: e.target.value })}
              readOnly={valueReadOnly}
              className={`w-full p-4 border-2 border-slate-100 rounded-2xl font-black outline-none ${
                valueReadOnly ? 'bg-slate-200 border-slate-300 text-slate-700 cursor-not-allowed' : 'bg-white'
              }`}
              placeholder={`Valor ${index + 1} (€)`}
            />

            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-1 px-2 flex items-center gap-2">
                <Calendar size={14} />
                Data Pagamento {index + 1}
              </label>
              <input
                type="date"
                value={payment.paymentDate}
                onChange={(e) => updatePayment(index, { paymentDate: e.target.value })}
                className="w-full p-3 bg-white border-2 border-slate-100 rounded-xl font-black text-sm outline-none focus:border-green-600"
              />
            </div>

            {isEditing && isAdminOrOwner && payment.method === PaymentMethod.CARD && (
              <div>
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-1 px-2 flex items-center gap-2">
                  <Clock size={14} />
                  Hora Pagamento {index + 1} (Multibanco)
                </label>
                <input
                  type="time"
                  value={payment.paymentTime || ''}
                  onChange={(e) => updatePayment(index, { paymentTime: e.target.value })}
                  className="w-full p-3 bg-white border-2 border-slate-100 rounded-xl font-black text-sm outline-none focus:border-green-600"
                />
              </div>
            )}
          </div>
        );
      })}

      {!isEmployeeComplexEditing && (
        <button
          type="button"
          onClick={addPayment}
          className="w-full p-4 border-2 border-dashed border-slate-200 rounded-2xl font-black flex items-center justify-center gap-2 text-slate-600 bg-white hover:bg-slate-50 hover:border-green-300 hover:text-green-700 transition-colors"
        >
          <Plus size={20} /> Adicionar Método de Pagamento
        </button>
      )}
    </div>
  );
}
